import { render, staticRenderFns } from "./TextBanner.vue?vue&type=template&id=d06ca526&scoped=true&"
import script from "./TextBanner.vue?vue&type=script&lang=js&"
export * from "./TextBanner.vue?vue&type=script&lang=js&"
import style0 from "./TextBanner.vue?vue&type=style&index=0&id=d06ca526&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d06ca526",
  null
  
)

export default component.exports